global.conmed = global.conmed || {};

/**
 * Lazy load country flag images in dropdown
 * Flags are only loaded when the dropdown is opened for the first time
 */
conmed.countryFlagsLazy = function ($) {
    'use strict';

    var that = {};
    var flagsLoaded = false;

    that.init = function () {
        // Load flags when country dropdown is shown (Bootstrap 5 event)
        $('#countryDropdown').closest('.dropdown').on('show.bs.dropdown', function () {
            if (!flagsLoaded) {
                loadFlags();
                flagsLoaded = true;
            }
        });

        // Also handle click on the dropdown toggle as fallback
        $('.country-dropdown > a, [data-bs-toggle="dropdown"]').closest('.dropdown').find('[data-bs-toggle="dropdown"]').on('click', function () {
            if (!flagsLoaded) {
                loadFlags();
                flagsLoaded = true;
            }
        });
    };

    function loadFlags() {
        $('.country-flag-lazy').each(function () {
            var $img = $(this);
            var src = $img.data('src');
            if (src && !$img.attr('src')) {
                $img.attr('src', src);
            }
        });
    }

    return that;
}(jQuery);
